module.exports = __webpack_public_path__ + "static/media/webvision4.a8efd053.png";